import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const ProfileIndexPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Activity is the profile landing tab.
    navigate('/profile/activity', { replace: true });
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="text.secondary">
        Redirecting to profile settings...
      </Typography>
    </Box>
  );
};

export default ProfileIndexPage;
